import { render, staticRenderFns } from "./CategoryListWidget.vue?vue&type=template&id=4590dff4&"
import script from "./CategoryListWidget.vue?vue&type=script&lang=js&"
export * from "./CategoryListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports